<template>
    <aside class="toolbox">
        <h4>Visualizations</h4>
        <p class="legend">
            Search your visualizations here and click use to
            add it into the report designer.
        </p>
        <b-form @submit.prevent="fetchData">
            <b-form-group>
                <b-input-group>
                    <b-form-input name="name"
                        type="text"
                        v-model="form.title"
                        placeholder="Visualization name">
                    </b-form-input>
                    <b-input-group-append>
                        <b-button type="submit" variant="primary">
                            <font-awesome-icon icon="search" />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <b-form-group>
                <b-form-select v-model="form.orderBy" :options="form.orderOptions" class="mb-3" size="sm" />
            </b-form-group>
        </b-form>
        <div v-if="loading">
            <spinner-component></spinner-component>
        </div>
        <div v-else>
            <table v-if="items.length > 0" class="table table-striped fixed_header">
                <tbody>
                    <tr v-for="(visualization) in items"  :key="visualization.id">
                        <td class="name">
                            {{ visualization.title }}
                        </td>
                        <td>
                            <b-button-group class="">
                                <b-button variant="success" size="sm" @click="use(visualization.id, visualization.type, visualization.query_id)">
                                    Use
                                </b-button>
                            </b-button-group>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else>
                <p><em>No results were found</em></p>
            </div>
        </div>
    </aside>
</template>

<script>
    import SpinnerComponent from './Spinner-loader.vue';
    import { mapState, mapActions } from 'vuex';
    export default {
        props: {
            visualization_id: {
                required: false
            }
        },
        data() {
            return {
                form: {
                    title: '',
                    orderBy: null,
                    orderOptions: [
                        { value: null, text: 'Order by' },
                        { value: 'asc', text: 'Oldest' },
                        { value: 'desc', text: 'Newest' }
                    ]
                },
                unwatch: '',
                loading: true
            }
        },
        components: {
            SpinnerComponent
        },
        computed: mapState('visualizations', {
            items: 'items',
            pagination: 'pagination'
        }),
        created() {
            this.fetchData().then(() => {
                if (this.visualization_id) {
                    for (let item in this.items) {
                        if (this.items[item].id == this.visualization_id) {
                            let visualization = this.items[item];
                            this.use(visualization.id, visualization.type, visualization.query_id);
                           break
                        }
                    }
                }
            });
            this.unwatch = this.$store.watch(
                (state)=>
                    this.$store.state.organizationSelected
                ,
                (newValue, oldValue)=>{
                    this.loading = true;
                    this.$store.dispatch('visualizations/fetch').finally(() => {
                        this.loading = false;
                    });
                },
            );
        },
        beforeDestroy() {
            this.unwatch();
        },
        methods: {
            ...mapActions({
                fetchByCriteria: 'visualizations/fetchVisualizationsByCriteria'
            }),
            ...mapActions('reports', {
                addChart: 'addChart',
                addBigNumber: 'addBigNumber'
            }),
            use(idVisualization, type, queryId) {
                let payload = {
                    id : idVisualization,
                    queryId: queryId
                };
                if (type === 'bigNumber') {
                    this.addBigNumber(payload)
                } else {
                    this.addChart(payload)
                }
            },
            fetchData() {
                return new Promise(resolve => {
                    this.loading = true;
                    let payload = {
                        'title': this.form.title,
                        'type': '',
                        'orderBy': this.form.orderBy ? this.form.orderBy : "desc",
                        };
                    this.fetchByCriteria(payload).then(() => {
                        this.loading = false;
                        resolve();
                    });
                })
            }
        },
        watch: {
            'form.orderBy'(val) {
                this.fetchData();
            }
        }
    }
</script>

<style scoped>
    .card {
        margin: 10px;
    }
    .report-toolbar {
        padding: 0;
    }

    .fixed_header tbody{
        display:block;
        width: 100%;
        overflow: auto;
        height: calc(100vh - 410px);
    }

    .fixed_header thead tr {
        display: block;
    }

    .fixed_header th, .fixed_header td {
        padding: 5px;
        text-align: left;
        width: 200px;
    }

    td.name {
        width: 100%;
    }
</style>

